export class Statistics{

    constructor() {
       
        this.ratingValue=0
        this.ratingCount=0
        this.viewsCount=0
        this.latestUpdateString=""
        this.latestUpdate=""
    }
    
    ratingValue:number
    ratingCount:number
    viewsCount:number
    latestUpdateString:string
    latestUpdate:string
}